export default __webpack_public_path__ + "static/media/home-preview-start-ups.abe51e5a.jpg";